// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2FKKv","alertIcon":"ConfirmModal_alertIcon__3fWUX"};